import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const sectorsData = [{
  title: "OUTDOOR CONCEPTS",
  description: "Outdoor Concepts provides professional excavation and site development services including site clearing, earthwork, grading, drainage installation, and utility work. Their field experience ensures construction is executed efficiently while meeting engineering specifications and project timelines.",
  image: "https://fluent-gnu.10web.cloud/wp-content/uploads/2026/03/Screen-Shot-2024-08-05-at-11.14.16-AM.png?v=anjnbmrtnrh",
  action: "View Investigations"
}, {
  title: "DESIGN CONCEPTS ENGINEERING",
  description: "Design Concepts Engineering provides civil and site engineering services for residential and commercial development projects. Their team specializes in site planning, grading and drainage design, stormwater management, and permitting support to help move projects from concept through construction.",
  image: "https://fluent-gnu.10web.cloud/wp-content/uploads/2026/03/Screenshot-2026-03-15-132713.png?v=5k536dvjz5q",
  action: "Explore Quality Control"
}];
export default function Sectors() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="5184" id="precisionindustrial" ref={ref} className="bg-background py-[60px] w-full overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className={`mb-12 text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-3xl md:text-4xl font-sans font-bold text-foreground relative inline-block uppercase tracking-tighter">Our Affiliated Companies</h2>
          <p className="mt-6 text-muted-foreground max-w-2xl mx-auto text-lg font-sans tracking-wide">Affiliated companies under shared ownership working together to investigate, design, and build projects from the ground up.</p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {sectorsData.map((sector, index) => <div key={index} data-index={index} className={`transition-all duration-700 ease-out delay-${index * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Card className="h-full flex flex-col bg-card border-[1px] border-border rounded-none shadow-lg p-[22px] hover:border-primary/50 transition-all duration-300">
                <div className="relative w-full h-64 md:h-72 mb-6 overflow-hidden rounded-none">
                  <img src={sector.image} alt={sector.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105 grayscale hover:grayscale-0" />
                </div>
                
                <CardHeader className="p-0 mb-4">
                  <CardTitle className="text-2xl md:text-3xl font-sans font-bold text-foreground uppercase tracking-tight">
                    {sector.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="p-0 mb-8 flex-grow">
                  <CardDescription className="text-base text-muted-foreground font-sans leading-relaxed">
                    {sector.description}
                  </CardDescription>
                </CardContent>
                
                <CardFooter className="p-0 mt-auto">
                  <Button asChild className="bg-primary text-primary-foreground rounded-none px-[22px] py-[14px] h-auto text-xs font-bold uppercase tracking-widest shadow-md hover:translate-y-[-2px] transition-all duration-150 ease-linear w-full sm:w-auto">
                    
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}